'use client';

import { Button } from '@/components/originui/button';
import { generateInvitationLink } from '@/utils/membership/generate-invitation-link';
import notify from '@/utils/shared/notify';
import { cn } from '@/utils/shared/Utils';
import { CheckIcon, CopyIcon } from 'lucide-react';
import { useState } from 'react';

interface CopyInviteLinkButtonProps {
  token: string;
}

export default function CopyInviteLinkButton({ token }: CopyInviteLinkButtonProps) {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(generateInvitationLink(token));

      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      notify.error('Kopiering av inbjudningslänk misslyckades');
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <Button
      variant="outline"
      className="disabled:opacity-100 w-full py-5"
      onClick={handleCopy}
      aria-label={copied ? 'Copied' : 'Copy to clipboard'}
      disabled={copied}
    >
      <div className="relative w-4 h-4">
        {/* Copy Icon (shown when idle) */}
        <CopyIcon
          className={cn('absolute transition-opacity duration-200', copied ? 'opacity-0' : 'opacity-100')}
          size={16}
          aria-hidden="true"
        />

        {/* Check Icon (shown when copied) */}
        <CheckIcon
          className={cn(
            'absolute transition-opacity duration-200 stroke-emerald-500',
            copied ? 'opacity-100' : 'opacity-0',
          )}
          size={16}
          aria-hidden="true"
        />
      </div>
      Kopiera inbjudningslänk
    </Button>
  );
}
